import { render, staticRenderFns } from "./OnTopicRegular.vue?vue&type=template&id=0d4c5dbc&"
import script from "./OnTopicRegular.vue?vue&type=script&lang=js&"
export * from "./OnTopicRegular.vue?vue&type=script&lang=js&"
import style0 from "./OnTopicRegular.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports